<template>
  <div>
        <div class="informationBox" v-if="pageSetInfo.fieldSet">
            <div class="informationTitle">{{pageSetInfo.fieldSet[0].defaultValStr}}</div>
            <div v-for="(fieldSetInfo,fieldSetIndex) in pageSetInfo.fieldSet" :key="'information_'+fieldSetIndex" >
                <div class="informationText" v-if="fieldSetIndex!=0">{{fieldSetInfo.fieldCnName}}:{{fieldSetInfo.defaultValStr}}</div>
                <kw_having_view :initDataInfo="dataInfo" :initpageSetInfo="pageSetInfo"></kw_having_view>
            </div>
        </div>
    </div>
</template>

<script>
import kw_having_view from '@/components/look/kw_having_view.vue';
export default {
  name: 'kw_information_card',
  props: {
    pageSetInfo:{
      type: Object,
      value: null
    },
    pageSetInfo: {
      type: Object,
      value: null
    }
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
      kw_having_view
  },
  methods: {
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.informationBox{padding: 10px;background: #fff}
.informationTitle{font-size: 16px;color: #393939;font-weight: bold}
.informationText{font-size: 14px;color: #777777;padding: 5px 0}
</style>
